import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=835940f2&"
import script from "./MonthlyReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyReport.vue?vue&type=style&index=0&id=835940f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports